import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import DtoDetailProjectSite_Project from "./DtoDetailProjectSite_Project";
import { EnumProductSiteEnvironment, EnumProductSiteEnvironmentOption } from "./EnumProductSiteEnvironment";
import UiGroup from "./UiGroup";

/**
 * 项目-站点详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailProjectSite extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
        this.Official = false;
    }

    [proName: string]: any;
    /**
     * 项目Id
     */
    ProjectId?: string;
    /**
     * 项目
     */
    Project?: DtoDetailProjectSite_Project;
    /**
     * 名称
     */
    Name?: string;
    /**
     * 编码
     */
    Code?: string;
    /**
     * 域名
     */
    Domain?: string;
    /**
     * 站点-Ip4
     */
    SiteIp4?: string;
    /**
     * 站点-IIS应用名称
     */
    SiteIisName?: string;
    /**
     * 站点-地址
     */
    SitePath?: string;
    /**
     * 数据库-连接地址
     */
    DbConnectionString?: string;
    /**
     * 环境
     */
    Environment?: EnumProductSiteEnvironment;
    /**
     * 是否为官方
     */
    Official?: boolean;
}

/**
 * 项目-站点详细-表单校验
 */
export const DtoDetailProjectSiteRules = {
}

/**
 * 项目-站点详细-设置项
 */
export const DtoDetailProjectSiteMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Project",
    Label: "项目",
    Customize: true,
  },
  {
    Prop: "Name",
    Label: "名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "编码",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Domain",
    Label: "域名",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "SiteIp4",
    Label: "站点-Ip4",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "SiteIisName",
    Label: "站点-IIS应用名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "SitePath",
    Label: "站点-地址",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "DbConnectionString",
    Label: "数据库-连接地址",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Environment",
    Label: "环境",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Enum,
    Options: EnumProductSiteEnvironmentOption,
  },
  {
    Prop: "Official",
    Label: "是否为官方",
    Type: EnumMiezzFormItemType.Text,
    Pipe: EnumPipe.Boolean,
    WhenTrue: "是",
    WhenFalse: "否",
  },
]
